export function getUserAgent(req?: Request): string {
  if (req) {
    return req?.headers?.['user-agent'];
  } else if (typeof window !== undefined) {
    return window?.navigator?.userAgent;
  } else {
    return '';
  }
}
